import { render } from "./sclfdzTreeDetail.vue?vue&type=template&id=79859124"
import script from "./sclfdzTreeDetail.vue?vue&type=script&lang=js"
export * from "./sclfdzTreeDetail.vue?vue&type=script&lang=js"

import "./sclfdzTreeDetail.vue?vue&type=style&index=0&id=79859124&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__